import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Article, ArticlesResult } from '../interfaces';
import { AuthService } from '../../services/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class ArticlesDataService {

  private uri: string = `${environment.apiUrl}list-article`;
  private headers:any ;

  constructor(
    private http: HttpClient
  ) {
    const jsonAuth = localStorage.getItem(AuthService.ATUH_STORAGE_KEY);
    if (jsonAuth) {
      const token = JSON.parse(jsonAuth)?.token;
      if (token) {
        this.headers = new HttpHeaders({
          enctype: 'multipart/form-data',
          authorization: 'bearer ' + token,
        });
      } 
    }
  }

  getArticles(): Observable<ArticlesResult|any> {
    return this.http.get(this.uri + "/all-articles");
  }

  addArticle(data: any): Observable<Article|any> {
    return this.http.post(this.uri + '/add', data, { headers :this.headers });
  }

  updateArticle(data: any,id:any): Observable<Article|any> {
    return this.http.post(this.uri + '/update'+ `/${id}`, data, { headers :this.headers });
  }

  deleteArticle(data: Article): Observable<null|any> {
    return this.http.put(this.uri + "/update_active" + `/${data.id}`, "");
  }

}
